import { Form, Modal, Button, Row, Spin, message } from 'antd'
import React from 'react'
import PropTypes from "prop-types";
import { useRecoilValue } from 'recoil';
import { isLoadingState } from '../recoil/states/default';

const ModalUC = (props) => {
    const {
        handleSubmit,
        handleSubmitFailed,
        handleCancel,
        children,
        open,
        width = "350px",
        title,
        isCanSave = true,
        showSave = true,
        showCancel = true,
        labelCancel = 'ยกเลิก',
        labelSave = 'บันทึก',
        form,
        centered = false,
        className = ''
    } = props

    // console.log('ModalUC', props)
    const onFinishFailed = () => {
        message.warning("warning", "กรุณาตรวจสอบข้อมูล")
        handleSubmitFailed();
    }

    const _isLoading = useRecoilValue(isLoadingState)
    return (
        <>
            <Modal className={'modal-uc ' + className}
                title={title}
                open={open}
                onCancel={!_isLoading ? handleCancel : undefined}
                footer={null}
                width={width}
                maskClosable={false}
                centered={centered}
            >
                <Spin tip="Loading..." spinning={_isLoading}>
                    <Form
                        className='modal-uc-form'
                        onFinish={handleSubmit}
                        form={form}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >
                        <div className='mb-4'>{children}</div>
                        {(showCancel || showSave) &&
                            <Row className='flex justify-center'>
                                <Form.Item className='mb-0'>
                                    {showCancel &&
                                        <Button
                                            className='mr-3'
                                            style={{ width: "150px" }}
                                            type="primary btn-color-default btn-clear"
                                            htmlType="button"
                                            loading={_isLoading}
                                            onClick={() => handleCancel()}
                                        >
                                            {labelCancel}
                                        </Button>
                                    }
                                    {showSave &&
                                        <Button
                                            type="primary btn-color-default btn-custom"
                                            htmlType="submit"
                                            loading={_isLoading}
                                            disabled={!isCanSave}
                                        >
                                            {labelSave}
                                        </Button>
                                    }
                                </Form.Item>
                            </Row>
                        }
                    </Form>
                </Spin>
            </Modal>
        </>
    )
}

ModalUC.proptype = {
    children: PropTypes.element,
};

export default ModalUC